import React, { useContext, useEffect, useState } from "react";
import styles from "./Start.module.scss";
import { Context } from "../Store";
import { motion } from "framer-motion";
import background3r from "../../imgs/background3r.png";
import background3l from "../../imgs/background3l.png";
import Images3 from "./Images3/Images3";
import Images1 from "./Images1/Images1";
import Images2 from "./Images2/Images2";
import Loading from "../Loading/Loading";

const Start = () => {
  let {
    dir,
    translate,
    setIsClicked,
    setIsHovering,
    variants0,
    variants1,
    variants3,
    startSection,
    clickBtn,
    clickbtns,
    experiencesRes,
    experiencesResData,
    experiencesLoading,
    siteInfoRes,
  } = useContext(Context);
  let { documentTitle, det0, btn } = translate.start;
  const { title, subTitle } = experiencesResData;
  const [start, setStart] = useState(0); //getStart components///
  const [experienceImagesLength, setExperienceImagesLength] = useState([]); //getStart components///

  useEffect(() => {
    setIsClicked(false);
    setIsHovering(false);
  }, [setIsClicked, setIsHovering]);
  useEffect(() => {
    document.title = dir === "ltr" ? documentTitle[0] : documentTitle[1];
  }, [dir]);
  useEffect(() => {
    setExperienceImagesLength(experiencesRes[start]?.images.length);
  }, [experiencesRes[start]]);
  return (
    <>
      <motion.section
        variants={variants1}
        initial="hidden"
        animate="showComponets"
        exit="exit"
        ref={startSection}
        id={styles.start}
      >
        {dir === "ltr" ? (
          <img className={styles.background3l} alt="" src={background3l} />
        ) : (
          <img className={styles.background3r} src={background3r} alt="" />
        )}
        <div className={styles.container}>
          {experiencesLoading ? (
            <Loading />
          ) : (
            <>
              <div className={styles.item0}>
                <p>{dir === "ltr" ? det0[0] : det0[1]}</p>
                <h3>{title}</h3>
                <p>{subTitle}</p>
                <a href={siteInfoRes?.googlePlay} target="_blank">
                  <button
                    onClick={() => clickBtn("startNow", 70)}
                    className={clickbtns === "startNow" ? "clickBtns" : ""}
                  >
                    {dir === "ltr" ? btn[0] : btn[1]}
                  </button>
                </a>
              </div>
              <div className={styles.item1}>
                {experiencesRes.map((experience, index) => (
                  <motion.div
                    animate={start === index ? "active" : "inactive"}
                    variants={variants0}
                    className={
                      start === index ? styles.active : styles.inactive
                    }
                    onClick={() => setStart(index)}
                    key={index}
                  >
                    <motion.img
                      src={experience.image}
                      className={
                        start === index ? styles.activeImg : styles.inactiveImg
                      }
                      alt=""
                      variants={variants3}
                      animate={start === index ? "active" : "inactive"}
                    />
                    <div
                      className={
                        start === index
                          ? styles.activeLayer
                          : styles.inactiveLayer
                      }
                    ></div>
                    {start === index ? (
                      <motion.p
                        variants={variants1}
                        initial={"hidden"}
                        animate={start === index ? "visible" : ""}
                        className={styles.pActive}
                      >
                        {index + 1} <span> •</span> {experience.title}
                      </motion.p>
                    ) : (
                      <p className={styles.pInactive}>{experience.title}</p>
                    )}
                  </motion.div>
                ))}
              </div>
            </>
          )}
        </div>
      </motion.section>
      {!experiencesLoading && experienceImagesLength === 3 ? (
        <Images3 experiencesRes={experiencesRes} start={start} />
      ) : !experiencesLoading && experienceImagesLength === 2 ? (
        <Images2 experiencesRes={experiencesRes} start={start} />
      ) : !experiencesLoading && experienceImagesLength === 1 ? (
        <Images1 experiencesRes={experiencesRes} start={start} />
      ) : (
        ""
      )}
    </>
  );
};

export default Start;
